import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import useTabs from '@/hooks/useTabs';
import { addObligationUrl } from '@/utils/urls';

const Page: FC = () => {
  const { t } = useTranslation();
  const title = t('obligations.create_new_title');
  const tabs = useTabs({
    parent: undefined,
    parentType: Parent_Type_Enum.Obligation,
    hrefRoot: addObligationUrl(),
    disabled: true,
  });

  return (
    <PageLayout title={title}>
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Obligation}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
